<div class="simple-notification-wrapper" [ngClass]="position">
  @for (a of notifications; track a; let i = $index) {
    <toast
      [item]="a"
      [timeOut]="timeOut"
      [clickToClose]="clickToClose"
      [clickIconToClose]="clickIconToClose"
      [maxLength]="maxLength"
      [showProgressBar]="showProgressBar"
      [pauseOnHover]="pauseOnHover"
      [theClass]="theClass"
      [rtl]="rtl"
      [animate]="animate"
      [position]="i"
    >
    </toast>
  }
</div>
